import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
// import elementEsLocale from 'element-ui/lib/locale/lang/es'// element-ui lang
import elementIdLocale from 'element-ui/lib/locale/lang/id'// element-ui lang
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang
import elementViLocale from 'element-ui/lib/locale/lang/vi'// element-ui lang
import elementThLocale from 'element-ui/lib/locale/lang/th'// element-ui lang
import elementPtLocale from 'element-ui/lib/locale/lang/pt'// element-ui lang
import enLocale from './en'
import zhCNLocale from './zh-cn'
// import esLocale from './es'
import idLocale from './id'
import zhTWLocale from './zh-tw'
import viLocale from './vi'
import thaiLocale from './thai'
import khmLocale from './khm'
import arLocale from './ar'
import ptLocale from './pt'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  id: {
    ...idLocale,
    ...elementIdLocale
  },
  'zh-cn': {
    ...zhCNLocale,
    ...elementZhLocale
  },
//   es: {
//     ...esLocale,
//     ...elementEsLocale
//   },
//   ja: {
//     ...jaLocale,
//     ...elementJaLocale
//   },
  'zh-tw': {
    ...zhTWLocale,
    ...elementZhTWLocale
  },
  vi: {  //越南語
    ...viLocale,
    ...elementViLocale
  },
  thai: {  //越南語
    ...thaiLocale,
    ...elementThLocale
  },
  khm: {  //越南語
    ...khmLocale,
    ...elementEnLocale
  },
  ar: {  //阿拉伯
    ...arLocale,
    ...elementEnLocale
  }
}
export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh-tw'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js